"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = react_1.default.memo(function Next() {
    return (react_1.default.createElement("svg", { width: "48", height: "48", viewBox: "0 0 48 48" },
        react_1.default.createElement("g", { fill: "none", fillRule: "evenodd", opacity: ".32" },
            react_1.default.createElement("path", { d: "M0 0H48V48H0z" }),
            react_1.default.createElement("path", { fill: "#736E7D", d: "M34 24L21.242 36.457c-.742.724-1.944.724-2.686 0-.741-.724-.741-1.898 0-2.623L28.628 24l-10.072-9.834c-.741-.725-.741-1.899 0-2.623.742-.724 1.944-.724 2.686 0L34 24z" }))));
});
